import {
  IBaseEvent,
  ParentEventFromSearch,
} from "../event-page-models/parent-event-from-search";
import { numberFromString } from "./mock-utils-functions";
import { ChildEvent } from "../event-page-models/child-event";

const buildFakeChildEventFromFather = (
  father: ParentEventFromSearch
): ChildEvent[] => {
  const numberOfChildEvents =
    numberFromString(father.eventName + father.parentEventCode, 7) + 2;
  const childEvents: ChildEvent[] = [];

  for (let i = 1; i <= numberOfChildEvents; i++) {
    const fatherEventWithoutChildren = { ...father };
    delete fatherEventWithoutChildren.childEvents;
    childEvents.push({
      ...(fatherEventWithoutChildren as IBaseEvent),
      childEventCode: father.parentEventCode + i * 7,
      parentEventCode: father.parentEventCode,
      childEventId: i * 10 + numberFromString(father.parentEventCode, 3),
      childEventPrice: i * 10,
      childEventPriceChange: [],
      circle: [],
      layers: [],
      nests: [],
      eventCollection: [],
    });
  }
  let listedKids = father.registeredChildren;
  const hashWaves: number[] = childEvents.map((c, i) =>
    numberFromString(
      c.parentEventCode.toString(),
      Math.ceil(listedKids / childEvents.length) * 2
    )
  );

  childEvents.forEach((c, i) => {
    const hashWave = hashWaves[i];
    const forThisChildListed = hashWave;
    const listedKidsBefore = listedKids;
    listedKids -= forThisChildListed;

    c.registeredChildren = forThisChildListed;
    // tslint:disable-next-line:curly
    if (listedKids <= 0) {
      c.registeredChildren = listedKidsBefore;
      listedKids = 0;
    } else if (i + 1 === hashWaves.length && listedKids > 0) {
      c.registeredChildren = listedKids;
    }
  });

  return childEvents;
};
export const childEventsMock = {
  buildFakeChildEventFromFather,
};



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/parent-events-mocks/child-events.mock.ts